import { unionFlag, getCityName } from "./index";
/**
 * 设置爬虫数据
 *
 */
export function setDocumentTitleInfo(title, keywords, description) {
  if (unionFlag() || sessionStorage.getItem('dffl_union')) {
    return;
  }
  if (title) {
    document.title = title;
  }
  if (keywords) {
    setMetaElementContent("keywords", keywords);
  }
  if (description) {
    setMetaElementContent("description", description);
  }
}

export function setMetaElementContent(name, content) {
  const meta = document.querySelector(`meta[name="${name}"]`);

  if (meta) {
    meta.setAttribute("content", content);
  } else {
    const meta = document.createElement("meta");
    meta.name = name;
    meta.content = content;
    document.getElementsByTagName("head")[0].appendChild(meta);
  }
}

const HASH = {
  "/drama_pc/home": [
    "东方福利网city-员工观演",
    "city员工观演,东方福利网",
    "东方福利网city，专业为员工提供演唱会、音乐会、话剧演出、舞蹈芭蕾、艺术展览、儿童亲子、休闲娱乐、曲苑杂坛、live现场门票预定及价格查询服务，满足员工个性化需求",
  ],
  "/drama_pc/list": [
    "东方福利网city-name企业团购/门票价格/门票预定",
    "cityname企业团购,cityname企业团购门票价格,cityname企业团购门票预定,东方福利网",
    "东方福利网city，专业为员工提供热门name门票预定及价格查询服务，满足员工个性化需求",
  ],
  "/drama_pc/detail": [
    "东方福利网上海-「开展营业中」address门票预定/时间地点",
    "「开展营业中」address,门票预订,时间地点查询,东方福利网",
    "东方福利网上海，专业为员工提供 「开展营业中」address门票预定，时间地点查询服务，满足员工个性化需求",
  ],
};

export function setTitleInfo(obj = {}) {
  const { name, address } = obj;
  const cityName = getCityName();
  const pathName = location.pathname;
  const currentItems = HASH[pathName] || [];

  const list = currentItems.map((element) => {
    let str = element.replace(/city/g, cityName);
    if (name) {
      str = str.replace(/name/g, name);
    }
    if (address) {
      str = str.replace(/address/g, address);
    }

    return str;
  });

  setTimeout(() => {
    setDocumentTitleInfo(list[0], list[1], list[2]);
  }, 500);
}
